import extractErrorMessage from '../utils/extractErrorMessage';
import { publicClient } from './client';

const fetchFilter = async (route, arrayName, filter = null) => {
  try {
    let query = '?';

    Object.entries(filter).forEach(([key, value]) => {
      if (value) {
        query += `&${key}=${encodeURIComponent(value)}`;
      }
    });

    const response = await publicClient.get(`/cars/filter${route}${query}`);

    return { data: response.data[arrayName], error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      `Došlo je do greške pri dobavljanju filtera: ${arrayName}.`
    );
    return { data: null, error: message };
  }
};

export const fetchYearsMade = async (filter) => {
  return fetchFilter('/years-made', 'years', filter);
};

export const fetchBodyworkTypes = async (filter) => {
  return fetchFilter('/bodywork-types', 'bodyworkTypes', filter);
};

export const fetchFuelTypes = async (filter) => {
  return fetchFilter('/fuel-types', 'fuelTypes', filter);
};

export const fetchEngineVersions = async (filter) => {
  return fetchFilter('/engine-versions', 'engineVersions', filter);
};

export const fetchGearboxTypes = async (filter) => {
  return fetchFilter('/gearbox-types', 'gearboxTypes', filter);
};

export const fetchDoorsCount = async (filter) => {
  return fetchFilter('/doors-count', 'doorsCount', filter);
};

export const fetchColors = async () => {
  try {
    const response = await publicClient.get(`/cars/color-options`);
    return { data: response.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju boja.'
    );
    return { data: null, error: message };
  }
};
